import { render } from "./collection-filter.vue?vue&type=template&id=17e9b62a"
import script from "./collection-filter.vue?vue&type=script&lang=js"
export * from "./collection-filter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__